import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MessageService } from '../message/message.service';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';
import { defaultPathForJwtRole } from '@gt/_helpers/role-routing.util';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
	private currentUserSubject: BehaviorSubject<any>;
	public currentUser: Observable<any>;

	constructor(
		private router: Router,
		private http: HttpClient,
		private messageService: MessageService,
		private jwtHelper: JwtHelperService
	) {
		this.currentUserSubject = new BehaviorSubject<any>(JSON.parse(localStorage.getItem('currentUser')));
		this.currentUser = this.currentUserSubject.asObservable();
	}

	public get currentUserValue() {
		let user = JSON.parse(localStorage.getItem('currentUser'));
		if (user) {
			return user;
		} else {
			return null;
		}
	}

	login(data) {
		return this.http.post<any>(`${environment.apiUrl}/login/authenticate`, data).pipe(
			map((data) => {
				if (data.success) {
					localStorage.setItem('currentUser', JSON.stringify(data.token));
					this.currentUserSubject.next(data);
					if (data.isFirstLogin === true) {
						this.router.navigate(['firsttimelogin']);
					} else {
						this.router.navigate([defaultPathForJwtRole(this.role)]);
					}
				} else {
					localStorage.removeItem('currentUser');
					this.currentUserSubject.next(data);
				}
				return data;
			})
		);
	}

	logout() {
		this.router.navigate(['login']).then(() => {
			this.messageService.sendMessage({
				success: false,
				message: 'You are now signed out',
			});
		});
		localStorage.removeItem('currentUser');
		const savedSettings = localStorage.getItem('userSettings') ?? null;
		localStorage.clear();
		if (savedSettings) localStorage.setItem('userSettings', savedSettings);

		this.currentUserSubject.next(null);
	}

	resetPasswordRequest(formData) {
		return this.http.post<any>(`${environment.apiUrl}/login/pwdResetRequest`, formData).pipe(
			map((data) => {
				return data;
			})
		);
	}

	updatePassword(formData) {
		return this.http.post<any>(`${environment.apiUrl}/login/firstLoginUpdate`, formData).pipe(
			map((data) => {
				if (data.success) {
					this.router.navigate([defaultPathForJwtRole(this.role)]);
				}
				return data;
			})
		);
	}

	resetPassword(formData) {
		return this.http.post<any>(`${environment.apiUrl}/login/ResetPwd`, formData).pipe(
			map((data) => {
				if (data.success === true) {
					this.router.navigate(['login']).then(() => {
						this.messageService.sendMessage({
							success: true,
							message: 'Your password has been updated. Please login with new password',
						});
					});
				} else {
					return data;
				}
			})
		);
	}

	public isAuthenticated(): boolean {
		const token = localStorage.getItem('currentUser');
		return !this.jwtHelper.isTokenExpired(token);
	}

	public get role() {
		const token = localStorage.getItem('currentUser');
		const decoded = this.jwtHelper.decodeToken(token);
		return decoded.role;
	}

	public get schools() {
		const token = localStorage.getItem('currentUser');
		const decoded = this.jwtHelper.decodeToken(token);
		return decoded.schools;
	}
	public get classrooms() {
		const token = localStorage.getItem('currentUser');
		const decoded = this.jwtHelper.decodeToken(token);
		return decoded.classrooms;
	}
}
